import { Avatar } from '@chakra-ui/react';
import { Flex, Text } from '@chakra-ui/layout';
// import avatar from 'assets/img/avatars/avatar10.png';

const UserAvatar = ({ name }: { name: string }) => (
    <Flex flexDirection="column">
        <Text fontWeight={700} fontSize="16px" color="gray.900" mb="16px">
            Avatar
        </Text>
        <Avatar src={undefined} width="88px" height="88px" name={name} />
    </Flex>
);

export default UserAvatar;
